<div class="row" *ngIf="service && !isLoading">
    <div class="col-12 pt-0 pl-4 pr-4">
  
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <div class="table-items">
              <div class="item">
                <div class="row cursor-row" (click)="
                service.highlight = !service.highlight; saveService();">
                  <div class="col-auto align-items-center justify-content-start">
                    <em id="showOnlyRegistrationFields" class="fas {{
                    service.highlight
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                    }}" style="vertical-align: middle;"></em>
                  </div>
                  <div class="col pl-0">
                    <label>{{'Highlight service' | translate}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="groups?.length">
        <div class="row">
          <div class="col">
            <label class="input-label">{{ 'Services list group' | translate }}</label>
            <div class="table-items">
              <div class="item">
                <div class="row align-items-center">
                  <div class="col">
                    <!--<select label=""
                      name="service.serviceGroup"
                      [(ngModel)]="service.serviceGroup"
                      (change)="updateServiceGroup($event)"
                      class="form-control">
                      <option *ngFor="let group of groups; let i = index" [attr.data-index]="i" [value]="group.id">
                        {{ group.name | translate }}
                      </option>
                    </select>-->
                    <ng-select [items]="groups"
                     bindLabel="name"
                     (change)="updateServiceGroup($event)"
                     [(ngModel)]="service.serviceGroup">
                    </ng-select>
                  </div>
                  <div class="col-auto pl-0">
                    <button class="btn btn-primary" (click)="editGroup();$event.stopPropagation()">{{ 'Add' | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="domains.length > 0">
        <div class="row">
          <div class="col-12">
            <label class="input-label">{{
              'Service domain' | translate
            }}</label>
            <div class="table-items">
              <div class="item">
                <div class="row">
                  <div class="col">
                    <select label=""
                      name="service.serviceJsonProperties.domain"
                      [(ngModel)]="service.serviceJsonProperties.domain"
                      (change)="onChange($event, publishing)"
                      class="form-control">
                      <option value="null" selected>All domains</option>
                      <option *ngFor="let domain of domains">
                        {{ domain }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label class="input-label">{{
              'Service order' | translate
            }}</label>
            <div class="table-items">
              <div class="item">
                <div class="row">
                  <div class="col">
                    <select label=""
                      name="service.sortOrder"
                      [(ngModel)]="service.sortOrder"
                      (change)="onChange($event, publishing)"
                      class="form-control">
                      <option *ngFor="let service of services; let i = index" [attr.data-index]="i" [value]="i">
                        {{ i }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label class="input-label">{{
              'service.attribute' | translate
            }}</label>
            <div class="table-items">
              <div class="item">
                <div class="row">
                  <div class="col">
                    <ng-select
                    bindLabel="text"
                    bindValue="id"
                    [clearable]="false"
                    [multiple]="true"
                    [(ngModel)]="selectedAttributes"
                    [items]="attributes"
                    (add)="selected($event)"
                    (remove)="removed($event)"></ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="form-group">
        <div class="row">
          <div class="col">
            <label class="input-label">{{ 'Categories' | translate }}</label>
            <div class="table-items">
              <div
              cdkDropList
              [cdkDropListData]="allCategories"
              (cdkDropListDropped)="dropped($event)">
                <div cdkDrag class="item" *ngFor="let cat of allCategories; let first = first; let last = last; let i = index" id="cat-{{cat.id}}">
                  <div class="row">
                    <div class="col-auto align-items-center justify-content-start">
                      <i cdkDragHandle class="cdk-drag-handle fa-solid fa-grip-dots handle ml-1"></i>
                    </div>
                    <div class="col-auto align-items-center justify-content-start pl-0">
                      <em  class="fas {{
                        isActivCatecory(cat)
                          ? 'fa-toggle-large-on toggle-primary'
                          : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                      }}" (click)="selectedCategory(cat)" style="vertical-align: middle;"></em>
                    </div>
                    <div class="col cursor-row px-0 align-items-center justify-content-start">
                      <inline-label-edit class="w-100"
                        (update)="updatecatName($event, cat)"
                        [label]="cat.category | translate"></inline-label-edit>
                    </div>
                    <div class="col-auto align-items-center justify-content-end">
                      <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-remove 3"
                        (click)="removeCatecory(cat); $event.stopPropagation()"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="row">
                  <div class="col-12 align-items-center justify-content-start">
                    <input label=""
                      [(ngModel)]="initialValue"
                      class="form-control"
                      type="text"
                      placeholder="{{ 'Add category' | translate }}">
                      <a (click)="submitEditOnFocus($event, categories);$event.stopPropagation()" style="position: absolute; top: calc(50% - 12px); right: 23px;" class="btn-dark {{initialValue.length ? '' : 'disabled'}} editBtn">{{"Add" | translate}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label class="input-label">{{
              'service.description' | translate
            }}</label>
            <div class="table-items">
              <div class="item">
                <div class="row">
                  <div class="col">
                    <textarea label=""
                    class="form-control"
                    name="description"
                    [(ngModel)]="service.description"
                    (focus)="startEdit($event)"
                    (focusout)="submitEditOnFocus($event, publishing);$event.stopPropagation()"
                    rows="6"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="form-group" *ngIf="service?.id">
        <div class="row">
          <div class="col">
            <label class="input-label">{{
              'service.logo' | translate
            }}</label>
            <file-handler
              [uploadPath]="'service/' + service.id + '/logo'"
              [fileId]="logoUrl"
              [label]="'Upload service logo'"
              [description]="'Service image used in services list'"
              (delete)="deleteLogo(true)"
              (fileIdChanged)="logoFileIdChanged($event)"></file-handler>
            <!--
            <div class="table-items">
              <div class="item">
                <div class="row">
                  <div class="col-5 align-items-center justify-content-start">
                    <service-file-uploader [serviceUrl]="'service/' + service.id + '/logo'"
                    (fileIdChanged)="logoFileIdChanged($event)"></service-file-uploader>
                  </div>
                  <div class="col-5 align-items-center justify-content-start">
                    <img *ngIf="logoUrl" src="{{ logoUrl }}" class="img-thumbnail" style="max-height: 64px;" />
                  </div>
                  <div class="col-2 align-items-center justify-content-end">
                    <confirmation [buttonName]="'general.delete'" [question]="'confirm.areyousure'" [showTrashIcon]="true"
                      (isConfirmed)="deleteLogo($event)" *ngIf="service?.id != undefined">
                    </confirmation>
                  </div>
                  
                </div>
              </div>
            </div>
          -->
          </div>
        </div>
      </div>
  
    </div>
  </div>
  
  <drawer [title]="'Edit group'"
          [contextLabel]="tempGroup?.name"
          [contextVariant]="'neutral'"
          [isClosed]="isDrawerClosed" (saveEvent)="saveGroup($event);" (closeEvent)="closeDrawer();" class="text-left">
    <group-manage [group]="tempGroup"></group-manage>
  </drawer>
